export default class FileUrlUtils {
  static getFileType(fileUrl) {
    const url = new URL(fileUrl);

    return url.pathname.split('.').pop().trim().toLowerCase();
  }

  static getFileName(fileUrl) {
    const url = new URL(fileUrl);

    return url.pathname.split('/').pop();
  }
}
